import { useState } from "react";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";
import { createCheckout } from "@/lib/api";

export default function Pricing() {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout(window.location.origin);
      window.location.href = checkout_url;
    } catch {
      toast.error(t.pricing.checkoutError);
      setLoading(false);
    }
  };

  return (
    <section id="licenza" className="py-24 px-6 border-b border-white/10 max-w-6xl mx-auto" data-testid="pricing-section">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="text-xs font-mono-code text-[#E2C079] uppercase tracking-widest block mb-2">{t.pricing.eyebrow}</span>
        <h2 className="font-serif-didot text-3xl sm:text-4xl text-white">{t.pricing.title}</h2>
      </div>

      <div className="max-w-xl mx-auto rounded-lg border-2 border-[#E2C079] bg-[#0f1b29] p-8 md:p-10 relative shadow-2xl" data-testid="pricing-card">
        <div className="absolute -top-3.5 right-6 px-3 py-1 bg-[#E2C079] text-[#0b131e] text-[10px] font-mono-code uppercase font-bold tracking-widest">
          {t.pricing.badge}
        </div>
        <div className="text-xs font-mono-code text-white/60 uppercase">{t.pricing.plan}</div>
        <div className="my-4 flex items-baseline gap-2">
          <span className="text-4xl sm:text-5xl font-serif-didot text-white font-bold" data-testid="pricing-price">{t.pricing.price}</span>
          <span className="text-xs text-white/50 uppercase font-mono-code">{t.pricing.priceNote}</span>
        </div>
        <p className="text-xs text-white/70 mb-6 pb-6 border-b border-white/10">{t.pricing.intro}</p>

        <div className="space-y-3 mb-8 text-xs font-mono-code text-white/80">
          {t.pricing.inclusions.map((item, i) => (
            <div key={item} className="flex items-center gap-2" data-testid={`pricing-inclusion-${i}`}>
              <span aria-hidden="true" className="text-[#E2C079]">✦</span>
              <span>{item}</span>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={handleCheckout}
          disabled={loading}
          data-testid="checkout-button"
          className="w-full py-4 bg-[#E2C079] text-[#0b131e] font-bold text-xs uppercase tracking-widest hover:bg-white transition-colors duration-300 disabled:opacity-60"
        >
          {loading ? t.pricing.loading : t.pricing.buy}
        </button>
        <p className="text-[10px] text-center text-white/40 font-mono-code mt-4">{t.pricing.secure}</p>
      </div>
    </section>
  );
}
